import React, { useState } from 'react'

import _ from 'lodash'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import utils from '../../utils'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { getFiltroJoinUnidade } from '../../utils/filter-utils'
import { InputText } from 'primereact/inputtext'

export default function LtsLookupTaxa(props) {
  const [filters, setFilters] = useState([])

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'grupoFinanceiro_oid',
      header: 'Cód. Grupo',
      columnKey: 'grupoFinanceiro_oid',
      sortable: true,
      filter: true,
      columnSortField: 'grupoFinanceiro.oid',
      relacionamento: ['grupoFinanceiro'],
      fieldJoin: 'oid',
      visible: true,
    },
    {
      field: 'grupoFinanceiro_descricao',
      header: 'Grupo',
      columnKey: 'grupoFinanceiro_descricao',
      sortable: true,
      filter: true,
      columnSortField: 'grupoFinanceiro.descricao',
      relacionamento: ['grupoFinanceiro'],
      fieldJoin: 'descricao',
      visible: true,
    },
    {
      field: 'valor',
      header: 'Valor',
      columnKey: 'valor',
      sortable: true,
      filter: true,
      columnSortField: 'valor',
      visible: true,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post('/lottustech/taxas/validas', params)
  }

  const onKeyPress = (e) => {
    const value = _.get(props, 'value', null)
    if (value) {
      const filters = [new Filtro('descricao', value, 'CONTEM', ['grupoFinanceiro'])]
      setFilters(filters)
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({
        oid: '',
        valor: '',
        grupoFinanceiro_tipo: '',
        grupoFinanceiro_descricao: value,
        grupoFinanceiro_oid: '',
      })
    } else {
      props.onChange(value)
    }
  }

  const autoCompleteTemplate = (taxa) => {
    const anoReferencia = _.get(taxa, 'anoReferencia', '')
    return `${taxa.grupoFinanceiro_descricao} ${anoReferencia}`
  }

  const onResolvingColumn = () => {
    return columns
      .filter(
        (col) =>
          col.field === 'oid' ||
          col.field === 'valor' ||
          col.field === 'grupoFinanceiro_oid' ||
          col.field === 'grupoFinanceiro_descricao'
      )
      .map((column) => {
        // Remove props that should not be spread to DOM elements
        const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = column

        if (column.field === 'oid') {
          return (
            <Column
              {...columnProps}
              key={column.field}
              bodyClassName="column-oid-body-width"
              filterHeaderClassName="column-oid-filter-header-width"
              headerClassName="column-oid-header-width"
              filterElement={columnFilterElement(column)}
            />
          )
        }
        if (column.field === 'grupoFinanceiro_oid') {
          return (
            <Column
              {...columnProps}
              key={column.field}
              bodyClassName="column-oid-grupo-body-width"
              filterHeaderClassName="column-oid-grupo-filter-header-width"
              headerClassName="column-oid-grupo-header-width"
              filterElement={columnFilterElement(column)}
            />
          )
        }
        if (column.field === 'valor') {
          return (
            <Column
              {...columnProps}
              key={column.field}
              body={(rowData) => utils.formatarDinheiro(rowData.valor)}
              bodyClassName="column-valor-body-width"
              filterHeaderClassName="column-valor-filter-header-width"
              headerClassName="column-valor-header-width"
              filterElement={columnFilterElement(column)}
            />
          )
        }
        return <Column key={column.field} {...columnProps} filterElement={columnFilterElement(column)} />
      })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' || campo === 'grupoFinanceiro_oid' || campo === 'valor' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    /**
     * filtro tipo: 1 = ENTRADA | 2 = SAIDA
     */
    const filtroTipoTaxa = _.get(props, 'filtroTipoTaxa', null)
    if (filtroTipoTaxa) {
      filters.push({
        campo: 'grupoFinanceiro_tipo',
        valor: filtroTipoTaxa,
        tipoFiltro: 'IGUAL_A',
      })
    }
    const filtroUnidade = getFiltroJoinUnidade(_.get(props, 'idUnidade', null))
    if (filtroUnidade) {
      filters.push(filtroUnidade)
    }
    if (props.resolveFilters) {
      props.resolveFilters(filters)
    }
    return filters
  }

  return (
    <React.Fragment>
      <LtsLookup
        label={props.label}
        value={props.value}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={autoCompleteTemplate}
        onKeyPress={onKeyPress}
        onInputFilter={onInputFilter}
        pathOnEdit={routes.PATH_TAXA_FINANCEIRO}
        header={props.header}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
      />
    </React.Fragment>
  )
}
